import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {DefaultPageProps} from "@models/DefaultProps.ts";
import {useFlags} from "@components/flags/hooks/useFlags.ts";
import {CreateFlagComponent} from "@components/flags/CreateFlagComponent.tsx";
import {useEffect, useMemo, useState} from "react";
import {IFlag} from "@models/shared/IFlag.ts";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {IGetFlagsFilter} from "@localization/siteMap/endpoints/flags/filters/IGetFlagsFilter.ts";
import {
    Button,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TextField
} from "@mui/material";
import {fullHeight} from "@models/helpers.ts";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {AddOutlined, FilterAlt, SearchOutlined} from "@mui/icons-material";
import {FlagInfoRow} from "@components/flags/info/FlagInfoRow.tsx";


interface FlagsPageProps extends DefaultPageProps {
    filtros?: IGetFlagsFilter
}

export function FlagsPage(props: FlagsPageProps) {
    const {filtros, preset, ...rest} = props;
    const {getFlags} = useFlags()
    const {addPopUp} = useAlert()

    const [filters, setFilters] = useState<IGetFlagsFilter>(filtros ?? {})
    const [flags, setFlags] = useState<IFlag[]>([]);
    const [pagination, setPagination] = useState<IPagination>({
        page: 1, pageSize: 10
    });

    useEffect(() => {
        if (pagination.page <= 0) {
            setPagination({...pagination, page: 1});
            return;
        }
        setPagination(prev => ({...prev, loading: true}));

        getFlags({pagination, filters}).then(x => {
            setFlags(x.items);
            setPagination(prev => ({...prev, ...x.pagination}));
        }).finally(() => {
            setPagination(prevPagination => ({...prevPagination, ignoreCache: false, loading: false}));
        });
    }, [pagination.page, pagination.ignoreCache]);

    const createComponent = useMemo(() => {
        return (<CreateFlagComponent preset={{...preset}} onCreate={() => {
            setPagination({...pagination, ignoreCache: true})
        }}/>)
    }, [preset, pagination]);

    return (
        <DefaultContainer {...rest}
                          titulo={'Sinalizações'}
                          pageProps={{pagination, setPagination}}
                          UpperComponent={<Grid container size={12} justifyContent={'space-between'}>
                              <Grid>
                                  <TextField type={'search'} value={filters.nome} size={'small'}
                                             label={'Nome'}
                                             onKeyDown={(e) => {
                                                 if (e.key == 'Enter') {
                                                     setPagination({...pagination, page: 0})
                                                 }
                                             }}
                                             slotProps={{
                                                 input: {
                                                     endAdornment: <>
                                                         <IconButton>
                                                             <FilterAlt/>
                                                         </IconButton>
                                                         <IconButton>
                                                             <SearchOutlined/>
                                                         </IconButton>
                                                     </>
                                                 }
                                             }}
                                             onChange={(e) => {
                                                 setFilters({
                                                     ...filters,
                                                     nome: e.target.value
                                                 })
                                             }}/>
                              </Grid>
                              <Grid>
                                  <Button onClick={() => {
                                      addPopUp({
                                          title: 'Criar nova sinalização',
                                          content: createComponent,
                                          size: 'xl'
                                      })
                                  }}
                                          endIcon={<AddOutlined/>}
                                          sx={{...fullHeight}}>Criar nova sinalização</Button>
                              </Grid>
                          </Grid>}
        >
            <TableContainer>
                <Table size={'small'}>
                    <TableHead>
                        <TableCell>Id</TableCell>
                        <TableCell>Nome</TableCell>
                        <TableCell>Tipo</TableCell>
                        <TableCell>Mais</TableCell>
                    </TableHead>
                    <TableBody>
                        {flags.map(x => {
                            return <FlagInfoRow value={x}/>
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </DefaultContainer>
    )
}